import { cv } from "./cv";
import { hr_ge } from "./hr-ge";
import { hr_am } from "./hr-am";
import { chefs } from "./chefs";
import { doctor } from "./doctor";


export const primengThemes = {
  'hr-ge': hr_ge,
  'cv': cv,
  'hr-am': hr_am,
  'chefs': chefs,
  'doctor': doctor
}